<template>
    <button :class="[buttonClass, buttonSizeClass]" class="label-xl hover-effect" @click="onClickEvent" :disabled="this.disabled">
        <div>
            {{ this.text }}
        </div>
    </button>
</template>

<style scoped>
.button-size-m {
    padding: 12px 16px;
}

.button-size-s {
    padding: 8px 16px;
}

.button-primary {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    background-color: var(--background-3);
    color: var(--content-3-pair);
    width: 100%;
    min-width: -webkit-fill-available;
    cursor: pointer;
    border: solid 1px transparent;
}

.button-primary:hover {
    background-color: var(--semantic-highlight-hover);
    color: var(--semantic-highlight);
    border: solid 1px transparent;
}

.button-primary:disabled {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    border: 0px solid var(--border-disable);
    min-width: -webkit-fill-available;
    background-color: var(--semantic-highlight-disable);
    color: var(--content-disable);
    cursor: none;
    pointer-events: none;
}

.button-secondary {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    color: var(--semantic-highlight);
    width: 100%;
    min-width: -webkit-fill-available;
    cursor: pointer;
    border: solid 1px var(--border-focus);
    background-color: transparent;
}

.button-secondary:hover {
    background-color: var(--semantic-highlight-hover);
    color: var(--semantic-highlight);
    border: solid 1px var(--border-focus);
}

.button-secondary:disabled {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    border: 1px solid var(--border-disable);
    min-width: -webkit-fill-available;
    background-color: var(--background-disable);
    color: var(--content-disable);
    cursor: none;
    pointer-events: none;
}

.button-tertiary {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    background-color: var(--background-1);
    color: var(--semantic-highlight);
    width: 100%;
    min-width: -webkit-fill-available;
    cursor: pointer;
    border: solid 1px transparent;
}

.button-tertiary:hover {
    background-color: var(--semantic-highlight-hover);
    color: var(--semantic-highlight);
    border: solid 1px transparent;
}

.button-tertiary:disabled {
    font-family: var(--font-family);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-m);
    border: 0px;
    min-width: -webkit-fill-available;
    background-color: var(--background-disable);
    color: var(--content-disable);
    cursor: none;
    pointer-events: none;
}
</style>

<script>
import * as buttonConstant from '@/constants/buttonConstant';

export default {
    name: 'ButtonComponent',
    setup() {
        return {
            buttonConstant
        }
    },
    props: {
        text: {
            String: Text,
            default: 'Button'
        },
        type: {
            type: String,
            default: buttonConstant.PRIMARY_TYPE_BUTTON,
            validator: (value) => [
                buttonConstant.PRIMARY_TYPE_BUTTON, 
                buttonConstant.SECONDARY_TYPE_BUTTON, 
                buttonConstant.TERTIARY_TYPE_BUTTON   
            ].includes(value),
        },
        size: {
            type: String,
            default: buttonConstant.MEDIUM_SIZE_BUTTON,
            validator: (value) => [
                buttonConstant.MEDIUM_SIZE_BUTTON, 
                buttonConstant.SMALL_SIZE_BUTTON
            ].includes(value),
        },
        onClickEvent: {
            type: Function,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        buttonClass() {
            return {
                'button-primary': this.type === 'primary',
                'button-secondary': this.type === 'secondary',
                'button-tertiary': this.type === 'tertiary'
            };
        },
        buttonSizeClass() {
            return {
                'button-size-m': this.size === buttonConstant.MEDIUM_SIZE_BUTTON,
                'button-size-s': this.size === buttonConstant.SMALL_SIZE_BUTTON
            };
        },
    }
}
</script>